import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnInit, HostBinding,
} from '@angular/core';
import { ModalBase } from '../modal-base';

@Component({
  selector: 'portal-base-modal',
  templateUrl: './base-modal.component.html',
  styleUrls: ['./base-modal.component.scss'],
  standalone: false,
})
export class BaseModalComponent extends ModalBase implements OnInit {
  @ViewChild('closeButton') closeButton: ElementRef;
  @Input() zIndex: number;
  @Input()
  set width(value: string) {
    this._width = value;
    this.updateModalWidth();
  }
  get width(): string {
    return this._width;
  }
  @Input() isManualFocusAdded? = false;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  // eslint-disable-next-line @typescript-eslint/naming-convention
  private _width = 'inherit';

  @HostBinding('style.--modal-width')
  hostModalWidth: string;
  constructor(public el: ElementRef) {
    super(el);
  }

  setFocusOnCloseButton(): void {
    if (this.closeButton && this.closeButton.nativeElement && this.isManualFocusAdded) {
      this.closeButton.nativeElement.focus();
    }
  }

  private updateModalWidth(): void {
    this.hostModalWidth = this._width;
  }
}
